import ReportShow from "../components/ReportShow";

export default function ReportRoute() {
  return <ReportShow />;
}
